var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlipinhoThugLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 273 276",
    width: 2400,
    height: 2426.3736263736,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    width: 273,
    height: 274,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M272.585 1.23H.668v273.73h271.917V1.23z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0096FA",
    d: "M136.627 236.717c90.325 0 135.958-13.375 135.958-107.57 0-97.02-55.397-127.917-135.958-127.917S.668 32.315.668 129.147c0 94.195 45.633 107.57 135.959 107.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0096FA",
    d: "M.668 129.335c0 25.244 3.944 48.228 10.329 68.951 9.201 29.765 23.098 54.444 36.994 73.66 1.502 2.072 3.756 3.014 5.821 3.014 2.254 0 4.507-1.13 6.01-3.203l25.914-37.301c15.587-25.809 3.944-64.617-15.023-94.383C43.296 97.12.668 72.253.668 129.335zM272.586 129.335c0 25.244-3.944 48.228-10.329 68.951-9.201 29.765-23.098 54.444-36.994 73.66-1.502 2.072-3.756 3.014-5.821 3.014-2.254 0-4.507-1.13-6.009-3.203l-25.915-37.301c-15.586-25.809-3.944-64.617 15.023-94.383 27.417-42.953 70.045-67.82 70.045-10.738z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0035B5",
    fillRule: "evenodd",
    d: "M51.103 156.828a3.003 3.003 0 0 1 2.998-3.008h165.254a3.003 3.003 0 0 1 2.998 3.008 3.003 3.003 0 0 1-2.998 3.009H54.101a3.004 3.004 0 0 1-2.998-3.009z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0035B5",
    d: "M131.47 156.828l-10.704 30.519c-2.629 7.536-9.765 12.433-17.652 12.057l-17.652-.754c-9.014-.376-16.338-7.159-17.276-16.201l-2.817-25.81h142.155l-2.817 25.81c-.939 8.854-8.263 15.825-17.276 16.201l-17.652.754c-7.887.376-15.023-4.521-17.652-12.057l-10.704-30.519"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0065FF",
    fillRule: "evenodd",
    d: "M192.639 180.504l1.314-19.215 7.234.498-1.315 19.215-7.233-.498z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlipinhoThugLife);
export default __webpack_public_path__ + "static/media/blipinho-thug-life.733c50973cdd03bf0dfa38a1226afc3b.svg";
export { ForwardRef as ReactComponent };